module.exports = __webpack_public_path__ + "img/facial_hair_full_beard_thick_extra_rect.b5018fd1.png";